import { AuthState, User } from "src/types/auth/authSchemas"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const getInitialState = ():AuthState => {
  const savedAuth = localStorage.getItem('authState')

  if (savedAuth) return JSON.parse(savedAuth)

  return {
    userId: null,
    isAuthenticated: false,
    user: null,
    token: null,
    tokenExp: null
  }
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: getInitialState(),
  reducers: {
    loginSuccess: (state, action: PayloadAction<{
      user: User,
      token: string,
      tokenExp: number
    }>) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.tokenExp = action.payload.tokenExp;
    },
    userSuccess: (state, action: PayloadAction<{
      id: string
    }>) => {
      state.userId = action.payload.id
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.tokenExp = null;
      state.userId = null;
    }
  }
})

export const { loginSuccess, userSuccess, logout } = authSlice.actions
